// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"142":"chunk_statsgrid","264":"chunk_metrics"}[chunkId] + "/oskari.min.css";
};